// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--xrGBv","label":"label--PAvJR","link":"link--xhqe7","dialogWrapper":"dialogWrapper--m9Vby","value":"value--jbqEN"};